import React from 'react'
import './Landing.css'
import Slogan from '../Slogan/Slogan';
import Roadmap from '../Roadmap/Roadmap';
import Content from '../Content/Content';




const Landing = () => {
  return (
    <div className='landing-container'>
        <Slogan/>
        <Roadmap/>
        <Content/>
    </div>
  )
}

export default Landing;